import { Link, List } from '@ksyos/design-system';
import type { OrganizationDataError } from '@common/interfaces/api/organizationDataErrorsApi';
import { OrganizationDataErrorType } from '@common/enums';
import { ListItem } from '@frontend/components/elements/List/List';
import { getSelectedLanguage } from '@frontend/translate';

type ErrorDetailsCellProps = {
    dataError: OrganizationDataError;
};

export default function ErrorDetailsCell({ dataError: { type, details } }: Readonly<ErrorDetailsCellProps>) {
    const translate = getSelectedLanguage();

    switch (type) {
        case OrganizationDataErrorType.duplicateAddress:
        case OrganizationDataErrorType.duplicateAgbCode:
        case OrganizationDataErrorType.duplicateNameStatutory:
        case OrganizationDataErrorType.duplicateKvkNumber:
            return (
                <>
                    {translate.dataChecks.duplicateOrganizations}
                    <List styleType="none">
                        {details?.duplicateOrganizations.map((organization) => {
                            const organizationUrl = `/organizations/${organization.id}/view/details`;

                            return (
                                <ListItem key={organization.id}>
                                    <Link
                                        onClick={(event) => event.stopPropagation()}
                                        rel="noreferrer"
                                        to={organizationUrl}
                                        variant="link"
                                    >
                                        {organization.txcsId}
                                    </Link>
                                </ListItem>
                            );
                        })}
                    </List>
                </>
            );
        case OrganizationDataErrorType.agbStartDateMismatch:
        case OrganizationDataErrorType.vektisAddressMismatch:
        case OrganizationDataErrorType.vektisKvkNumberMismatch:
        case OrganizationDataErrorType.vektisNameStatutoryMismatch:
            return (
                <List styleType="none">
                    <ListItem>
                        <span className="font-weight-bold">{translate.common.clientSafe}</span>: {details?.clientSafe}
                    </ListItem>
                    <ListItem>
                        <span className="font-weight-bold">{translate.common.vektis}</span>: {details?.vektis}
                    </ListItem>
                </List>
            );
        default:
            return <></>;
    }
}
